export default {
  nav: {
    home: "首页",
    aboutUs: "关于我们",
    products: "产品",
    quality: "品质",
    sustainability: "可持续发展",
    globalReach: "全球市场",
    contact: "联系我们",
  },
  quick: {
    whatsapp: "WhatsApp",
    zalo: "Zalo",
    wechat: "微信",
    qrTitle: "通过 {{app}} 与我们联系",
    qrDesc: "使用 {{app}} 扫描下方二维码，即可直接与我们的出口团队沟通。",
    qrPlaceholder: "{{app}} 二维码",
    qrStepsTitle: "扫码方法",
    qrStep1: "在手机上打开 {{app}}，进入扫码界面。",
    qrStep2: "将镜头对准下方二维码，打开我们的联系人页面。",
    qrStep3: "发送消息，我们的团队将在一个工作日内回复。",
    qrClose: "关闭",
    callNow: "立即致电",
    callTitle: "致电我们的出口团队",
    callDesc: "直接联系出口部门 —— 工作时间内我们随时为您提供支持。",
    callLabel: "电话号码",
    callCopy: "复制号码",
    callCopied: "已复制",
    callClose: "关闭",
    open: "打开快捷联系",
    close: "关闭快捷联系",
  },
  footer: {
    heading: "携手共创\n更美好的未来",
    cta: "立即联系",
    rights: "© 2026 EverRice 版权所有。",
    email: "info@everrice.vn",
    location: "越南 胡志明市",
    company: "永禾有限公司",
  },
  home: {
    hero: {
      eyebrow: "您值得信赖的合作伙伴",
      title: "让越南大米走向世界",
      sub1: "优质大米 。可持续发展。",
      sub2: "共创美好未来，造福人与社区。",
      cta: "我们的产品",
    },
    about: {
      eyebrow: "关于 EverRice",
      title1: "扎根越南",
      title2: "携手共进，走向全球",
      desc: "我们是一家越南大米出口企业，致力于将高品质大米供应到全球市场，同时为农民、合作伙伴与社区创造可持续价值。",
      cta: "了解更多",
      features: [
        { title: "卓越品质", desc: "精选自肥沃的良田" },
        { title: "全球供应", desc: "深受全球合作伙伴信赖" },
        { title: "可持续成长", desc: "为了人们、社区与环境" },
      ],
    },
    products: {
      eyebrow: "我们的产品",
      title: "越南好米，\n成就美好未来",
      desc: "从优质香米到精选白米、糯米及各类特色米种，EverRice 自豪地将越南优质大米带向世界，让越南好米的卓越品质与独特风味走进全球各地的餐桌。",
      cta: "浏览产品",
      items: [
        { name: "香米", desc: "香气清雅，口感细腻" },
        { name: "白米", desc: "品质稳定" },
        { name: "糯米", desc: "营养丰富" },
        { name: "特色米", desc: "品种独特" },
      ],
    },
    stats: [
      { value: "15+", label: "出口国家" },
      { value: "20万", label: "年发货吨数" },
      { value: "4万", label: "吨/月供应能力" },
      { value: "14", label: "年专业经验" },
    ],
    globalReach: {
      eyebrow: "全球市场",
      title: "从越南走向世界",
      desc: "我们向亚洲、北美、欧洲、非洲及其他地区的市场供应优质大米。",
      cta: "我们的市场",
    },
    sustainability: {
      eyebrow: "可持续发展",
      title: "今天用心耕耘\n成就明日世代",
      desc: "我们与农户紧密合作，推广可持续的耕作方式，共同创造更绿色、更健康的未来。",
      cta: "我们的承诺",
      features: [
        { title: "支持农户" },
        { title: "环境责任" },
        { title: "壮大社区" },
      ],
    },
  },
  aboutPage: {
    hero: {
      eyebrow: "关于 EVERRICE",
      title: "扎根越南，走向全球",
      desc: "一家值得信赖的越南大米出口企业，致力于品质与诚信，并与农民及全球大米进口商建立长久的合作伙伴关系。",
    },
    story: {
      eyebrow: "我们的故事",
      title: "从一家小型大米出口商到值得信赖的全球伙伴",
      p1: "EverRice 最初只是一家小型越南大米出口企业，坚守对品质、诚信与信任的朴实承诺。通过与农户和客户的紧密合作，我们在每一次出货和每一段关系中不断成长。",
      p2: "如今，我们将越南最优质的稻米与全球大米进口商相连。虽然我们的版图不断扩大，但我们的价值观始终如一——建立长久的合作伙伴关系，交付值得信赖的品质。",
      ctaProducts: "我们的产品",
      ctaContact: "联系我们",
    },
    pillars: {
      eyebrow: "驱动我们的力量",
      title: "使命、愿景与价值观",
      items: [
        {
          title: "我们的使命",
          desc: "将优质的越南大米带给世界，同时与农民及全球大米进口商建立长久的合作伙伴关系。",
        },
        {
          title: "我们的愿景",
          desc: "成为全球市场中最值得信赖的越南大米合作伙伴，以品质与诚信著称。",
        },
        {
          title: "我们的价值观",
          desc: "品质至上。可持续成长。诚信。诚实合作。尊重。",
        },
      ],
    },
    values: {
      eyebrow: "核心价值观",
      title: "指引我们的原则",
      items: [
        { title: "品质至上", desc: "我们绝不妥协所交付产品的品质。" },
        {
          title: "可持续成长",
          desc: "我们着眼长期成功，为合作伙伴与我们所在的社区创造价值。",
        },
        {
          title: "诚信",
          desc: "我们做正确的事，信守承诺，并为自己的行为负责。",
        },
        {
          title: "诚实合作",
          desc: "我们相信长久的商业关系建立在透明、信任与共赢之上。",
        },
        {
          title: "尊重",
          desc: "我们珍视农户、合作伙伴、客户，以及每一位为我们的旅程做出贡献的人。",
        },
      ],
    },
    facilities: {
      eyebrow: "每一粒米背后",
      title: "从稻田到您的港口",
      sub: "一条完全可追溯的链条——采购、碾磨与检测。",
      items: [
        { title: "源自湄公河三角洲" },
        { title: "在现代化工厂中加工" },
        { title: "经认证实验室检测" },
      ],
    },
    stats: [
      { value: "14", label: "年专业经验" },
      { value: "15+", label: "出口国家" },
      { value: "4万", label: "吨/月供应能力" },
      { value: "20万", label: "年发货吨数" },
    ],
  },
  productsPage: {
    hero: {
      eyebrow: "我们的产品",
      title: "越南好米,成就美好未来",
      desc: "从优质香米到高品质白米、糯米及特色米种，EverRice 自豪地将越南优质大米带上世界各地的餐桌。",
    },
    grid: {
      categories: [
        { key: "all", label: "全部产品" },
        { key: "fragrant", label: "香米" },
        { key: "white", label: "白米" },
        { key: "brown", label: "糯米" },
        { key: "specialty", label: "特色米" },
      ],
      labels: { grade: "粒长", packing: "包装", moisture: "水分" },
      items: [
        {
          cat: "fragrant",
          name: "茉莉香米",
          desc: "柔软、芬芳、自然回甜——我们的招牌泰式茉莉香米长粒米。",
          grade: "优质 5% 碎米",
          packaging: "1kg / 5kg / 25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "香长粒米",
          desc: "带有淡淡的班兰叶香气，质地轻盈蓬松，煮后依然柔软。",
          grade: "优质 5% 碎米",
          packaging: "5kg / 10kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "ST25 香米",
          desc: "屡获殊荣的优质长粒米，米粒柔软，自然回甜，香气淡雅。",
          grade: "优质 5% 碎米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "fragrant",
          name: "香花米",
          desc: "米粒细长的香米，以淡雅花香与柔韧口感著称。",
          grade: "优质 5% 碎米",
          packaging: "5kg / 10kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 5%",
          desc: "日常标准之选——洁净、稳定，非常适合日常餐饮和配餐。",
          grade: "5% 碎米",
          packaging: "10kg / 25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 15%",
          desc: "高性价比的可靠等级，适合餐饮、加工及大批量采购客户。",
          grade: "15% 碎米",
          packaging: "25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "白米 10%",
          desc: "均衡的日常等级——洁净、顺滑、精碾，适合日常烹饪与配餐。",
          grade: "10% 碎米",
          packaging: "25kg / 50kg",
          moisture: "最高 14%",
        },
        {
          cat: "white",
          name: "日本米",
          desc: "短圆粒，油亮黏糯——寿司与日式料理的理想之选。",
          grade: "短粒",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14%",
        },
        {
          cat: "brown",
          name: "糙米",
          desc: "保留麸皮的全谷米——坚果香、营养丰富、富含膳食纤维。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "红米",
          desc: "别具一格的红色麸皮，口感紧实，带有温暖质朴的风味。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "白糯米",
          desc: "油亮、柔韧、自然黏糯——节庆佳肴与传统甜点的经典之选。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "brown",
          name: "班兰糯米",
          desc: "带有淡淡班兰香气的香糯米，色泽柔和微绿。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "specialty",
          name: "黑糯米",
          desc: "油亮、自然甘甜、黏糯——传统甜点的理想之选。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
        {
          cat: "specialty",
          name: "有机茉莉香米",
          desc: "获得有机认证，不使用合成农药种植，成就最洁净的餐桌。",
          grade: "有机认证",
          packaging: "1kg / 5kg",
          moisture: "最高 14%",
        },
        {
          cat: "specialty",
          name: "发芽糙米",
          desc: "富含 GABA 的发芽糙米——营养升级，口感更柔软、更具坚果香。",
          grade: "发芽米",
          packaging: "1kg / 5kg",
          moisture: "最高 14%",
        },
        {
          cat: "specialty",
          name: "红血米",
          desc: "罕见的深红珍稀米种，色泽浓郁，口感紧实、营养丰富。",
          grade: "全谷米",
          packaging: "1kg / 5kg / 25kg",
          moisture: "最高 14.5%",
        },
      ],
    },
    certs: {
      eyebrow: "品质保证",
      title: "每一步都获得认证",
      desc: "每一批大米在出厂前都会经过纯度、水分和食品安全检测。",
      items: [
        { title: "HACCP", desc: "通过食品安全管理认证" },
        { title: "ISO 22000", desc: "全球食品安全标准" },
        { title: "有机认证", desc: "获得认证的有机品种" },
        { title: "GLOBALG.A.P.", desc: "负责任的耕作规范" },
      ],
    },
    packaging: {
      eyebrow: "灵活的选择",
      title: "为每一位买家量身包装",
      items: [
        { title: "零售包装", desc: "1kg、2kg 和 5kg 零售装，适合超市和电商。" },
        {
          title: "大包装",
          desc: "25kg 和 50kg 编织袋或纸袋，适合分销商和加工商。",
        },
        {
          title: "整柜运输",
          desc: "20 尺和 40 尺整柜运输，提供灵活的 FCL 与 LCL 条款。",
        },
      ],
      box: {
        title: "需要定制规格吗？",
        desc: "告诉我们您的等级、数量与目的地——我们将为您准备专属报价。",
        cta: "索取报价",
      },
    },
  },
  qualityPage: {
    hero: {
      eyebrow: "品质保障",
      title: "粒粒好米,品质见真章",
      desc: "稳定的标准、严格的检测与完整的可追溯性——这正是我们赢得超过 15 个国家买家信任的方式。",
    },
    intro: {
      eyebrow: "我们的承诺",
      title: "我们始终坚守的标准",
      desc: "好米并非偶然。它源自精心挑选的稻谷、精准的碾磨，以及每一个检查环节的坦诚。我们的团队对每一批货进行检验，确保出厂的产品正是合作伙伴所期望的——批次如一。",
      highlights: [
        {
          title: "每批都经实验室检测",
          desc: "每一批货在批准前都会抽样分析水分、纯度与碎米率。",
        },
        {
          title: "全程可追溯",
          desc: "从稻田到集装箱编号——每一步都有记录、可验证。",
        },
        {
          title: "认证标准",
          desc: "运营符合 HACCP、ISO 22000 和 GLOBALG.A.P. 食品安全框架。",
        },
      ],
    },
    process: {
      eyebrow: "我们的流程",
      title: "五大检查点，一份对品质的承诺",
      items: [
        {
          step: "01",
          title: "产地甄选",
          desc: "我们精选来自认证种植区域合作农场的稻谷，确保来源可追溯至具体田块。",
        },
        {
          step: "02",
          title: "可控碾磨",
          desc: "采用现代化工厂，配备已校准的脱壳与抛光工序，达到一致的碾磨精度。",
        },
        {
          step: "03",
          title: "实验室检测",
          desc: "对样品进行水分、碎米、杂质和食品安全指标的检测。",
        },
        {
          step: "04",
          title: "精准包装",
          desc: "在受控条件下使用洁净的食品级包装，按订单封口并贴标。",
        },
        {
          step: "05",
          title: "出货文件齐全",
          desc: "每批货物均随附质量证明及检测分析报告，确保全程透明、信息清晰。",
        },
      ],
    },
    specs: {
      eyebrow: "技术标准",
      title: "我们所检测的指标",
      sub: "典型的出口规格。最终参数按合同与每位买家协商确定。",
      head: { param: "指标", standard: "标准", method: "检测方法" },
      rows: [
        { param: "水分含量", standard: "最高 14.0%", method: "ISO 712" },
        { param: "碎米率", standard: "按等级 5% / 15%", method: "ISO 7301" },
        { param: "杂质", standard: "最高 0.10%", method: "目视与过筛" },
        { param: "稻谷粒", standard: "每公斤最多 5 粒", method: "人工计数" },
        { param: "碾磨精度", standard: "精碾", method: "目视评估" },
        { param: "白度指数", standard: "40+", method: "白度仪" },
      ],
    },
    labs: {
      eyebrow: "幕后花絮",
      title: "品质诞生的地方",
      items: [
        { title: "稻米检验" },
        { title: "检测实验室" },
        { title: "可控仓储" },
      ],
    },
    certs: {
      eyebrow: "获得国际认可",
      title: "层层把关，认证保障",
      desc: "通过独立审核及国际认可的认证体系，切实印证我们对合作伙伴所作出的品质承诺。",
      items: [
        { title: "HACCP", desc: "危害分析与关键控制点" },
        { title: "ISO 22000", desc: "全球食品安全管理" },
        { title: "有机认证", desc: "获得认证的有机品种" },
        { title: "GLOBALG.A.P.", desc: "负责任的耕作规范" },
      ],
    },
    stats: [
      { value: "100%", label: "批次经实验室检测" },
      { value: "24小时", label: "平均检测周转时间" },
      { value: "0.1%", label: "最大杂质含量" },
      { value: "5", label: "品质检查关卡" },
    ],
    cta: {
      title: "索取我们的品质文件",
      desc: "每笔订单均可提供规格说明、分析证书及检验报告。告诉我们您的需求，我们将为您准备好相关细节。",
      ctaContact: "联系我们",
      ctaProducts: "我们的产品",
    },
  },
  sustainabilityPage: {
    hero: {
      eyebrow: "可持续发展",
      title: "责任耕耘，共创未来",
      desc: "我们相信，优质大米不应以环境为代价。每一次收获，都是守护土地、关爱农民、回馈社区的机会。",
    },
    intro: {
      eyebrow: "我们的理念",
      title: "今天用心耕耘，成就明日世代",
      p1: "我们与耕耘稻田的种植者并肩合作，分享知识，并投资于保护土壤、节约用水、保障其生计的实践。",
      p2: "从田间到工厂，我们减少浪费、使用更清洁的能源，并让供应链保持透明，让每一袋大米都承载更轻的足迹与更公平的故事。",
      ctaQuality: "我们的品质",
      ctaWork: "与我们合作",
    },
    pillars: {
      eyebrow: "我们坚守的理念",
      title: "我们承诺的三大支柱",
      items: [
        {
          title: "支持农户",
          desc: "公平的价格、长期的合同与培训，帮助合作家庭从容发展。",
        },
        {
          title: "环境责任",
          desc: "节水灌溉、有机耕作，以及工厂中的可再生能源应用。",
        },
        {
          title: "壮大社区",
          desc: "在我们种植大米的地方，投资当地学校、清洁水源与发展机会。",
        },
      ],
    },
    initiatives: {
      eyebrow: "切实行动",
      title: "贯穿供应链的举措",
      sub: "这些具体的项目，让我们的米对人们和地球都更好。",
      items: [
        {
          title: "节水灌溉",
          desc: "采用干湿交替技术，在保持高产的同时减少用水量。",
        },
        {
          title: "有机耕作",
          desc: "减少化学投入、以自然方式养护土壤，培育更健康、更洁净的稻田。",
        },
        {
          title: "公平贸易定价",
          desc: "透明的合同，为农户的收成提供稳定而公平的收入。",
        },
        {
          title: "农户培训",
          desc: "田间学校为合作种植者传授现代化、可持续的技术。",
        },
        { title: "可再生能源", desc: "太阳能与生物质能为碾米作业降低碳足迹。" },
        {
          title: "减少浪费",
          desc: "稻壳和米糠被再利用为生物质燃料和动物饲料，而非废弃。",
        },
      ],
    },
    goals: {
      eyebrow: "我们的 2030 目标",
      title: "我们前行的方向",
      items: [
        {
          value: "100%",
          label: "负责任采购的大米",
          desc: "到 2030 年，全部大米采购自认证的可持续种植者。",
        },
        {
          value: "30%",
          label: "减少用水量",
          desc: "降低合作农场每吨稻谷的灌溉用水。",
        },
        {
          value: "50%",
          label: "可再生能源",
          desc: "一半的碾米能源来自太阳能与生物质能。",
        },
        {
          value: "20,000",
          label: "培训农户",
          desc: "扩大我们的可持续农耕教育项目。",
        },
      ],
    },
    stats: [
      { value: "12,000", label: "受支持的合作农户" },
      { value: "4,500 公顷", label: "可持续耕作面积" },
      { value: "30%", label: "每次收获节省的用水" },
      { value: "18", label: "年携手成长" },
    ],
    cta: {
      title: "与我们携手，共创更美好的事物",
      desc: "与一家关心品质、人们与地球的大米出口企业合作。让我们共同打造更具责任感的供应链。",
      ctaContact: "联系我们",
      ctaProducts: "我们的产品",
    },
  },
  globalReachPage: {
    hero: {
      eyebrow: "全球市场",
      title: "从越南走向世界",
      desc: "我们向亚洲、北美、欧洲、非洲及其他地区的市场供应优质大米。",
      cta: "我们的市场",
      stats: [
        { value: "30+", label: "国家与地区" },
        { value: "100+", label: "信赖合作伙伴" },
        { value: "1M+", label: "年供应吨数" },
      ],
    },
    overview: {
      eyebrow: "我们的网络",
      title: "一条供应链，多个市场",
      p1: "EverRice 将湄公河三角洲肥沃的稻田与全球各地的进口商、分销商和零售商相连。二十多年来，我们建立了长期的合作关系，让单次订单转变为可靠的伙伴关系。",
      p2: "从出口单据和质量证书，到定制包装与发运计划，我们的团队处理每一个细节，让您的货架持续充盈——一季又一季。",
      ctaProducts: "我们的产品",
      ctaQuote: "索取报价",
      stats: [
        { value: "25+", label: "出口市场" },
        { value: "20万", label: "年发货吨数" },
        { value: "5", label: "服务的大洲" },
        { value: "24小时", label: "报价响应时间" },
      ],
    },
    map: {
      eyebrow: "出口市场",
      title: "让优质越南大米走向世界",
      labels: {
        markets: "市场",
        ofVolume: "占出货量",
        growth: "增长",
        keyMarkets: "核心市场",
        viewAria: "查看出口数据",
      },
      countries: {
        spain: "西班牙",
        austria: "奥地利",
        dubai: "迪拜",
        ghana: "加纳",
        russia: "俄罗斯",
        canada: "加拿大",
        usa: "美国",
        china: "中国",
        hongkong: "香港",
        philippines: "菲律宾",
        malaysia: "马来西亚",
        singapore: "新加坡",
        indonesia: "印度尼西亚",
        australia: "澳大利亚",
        solomon: "所罗门群岛",
      },
      regions: [
        {
          name: "亚洲",
          tagline: "我们最大、历史最悠久的市场",
          desc: "从东京到马尼拉，我们的香米和白米是亚洲餐桌上的可靠主粮——按长期合同全年供应。",
          growth: "同比 +12%",
          volume: "19 万吨",
          markets: ["日本", "菲律宾", "中国", "韩国", "新加坡", "马来西亚"],
        },
        {
          name: "中东",
          tagline: "快速成长的合作伙伴地区",
          desc: "我们为海湾地区的酒店、零售商和分销商供应稳定、精碾、贴合当地口味并符合清真要求的大米。",
          growth: "同比 +18%",
          volume: "13 万吨",
          markets: ["阿联酋", "沙特阿拉伯", "卡塔尔", "科威特", "阿曼"],
        },
        {
          name: "欧洲",
          tagline: "为挑剔买家提供优质品质",
          desc: "欧洲进口商信赖我们可追溯的供应链、严格的质量控制，以及每个集装箱都可靠的单据。",
          growth: "同比 +9%",
          volume: "9.5 万吨",
          markets: ["德国", "荷兰", "波兰", "英国", "法国"],
        },
        {
          name: "非洲",
          tagline: "携手共建粮食安全",
          desc: "我们以可靠的货源和灵活的包装方案，支持西非和南部非洲的批发商及援助项目。",
          growth: "同比 +15%",
          volume: "5.5 万吨",
          markets: ["加纳", "科特迪瓦", "南非"],
        },
        {
          name: "美洲",
          tagline: "拓展新的海岸",
          desc: "这是 EverRice 较新的市场，我们以正宗的越南品种，服务北美各地的亚洲食品零售商和分销商。",
          growth: "同比 +21%",
          volume: "3 万吨",
          markets: ["美国", "加拿大"],
        },
      ],
    },
    regionStats: {
      eyebrow: "用数据说话",
      title: "我们的规模与实力",
      sub: "我们五个目的地地区的年度参考量。",
      marketsUnit: "个目的地市场",
      shareUnit: "的出口总量",
    },
    keyMarkets: {
      eyebrow: "核心目的地",
      title: "深受全球买家信赖",
      items: [
        {
          country: "菲律宾",
          region: "亚洲",
          note: "大批量采购香米和白米。提供集装箱及散货船装运选项。",
        },
        {
          country: "中国",
          region: "亚洲",
          note: "大批量采购香米和糯米。主要以集装箱装运。",
        },
        {
          country: "新加坡",
          region: "亚洲",
          note: "区域食品分销、批发与餐饮贸易中心。",
        },
        {
          country: "中国香港",
          region: "亚洲",
          note: "香米与寿司米的高端市场。",
        },
      ],
    },
    logistics: {
      eyebrow: "从稻田到港口",
      title: "优化物流，简化流程",
      items: [
        {
          title: "采购与碾磨",
          desc: "稻谷取自合作农场，并在我们现代化、严控品质的工厂中碾磨。",
        },
        {
          title: "品质检验",
          desc: "每一批货在批准前都会经过水分、碎米和纯度的实验室检测。",
        },
        {
          title: "包装与装柜",
          desc: "按您的确切规格进行袋装或散装集装箱装箱及打托。",
        },
        {
          title: "海运",
          desc: "经由越南主要港口发运，全程处理完整的出口单据。",
        },
        {
          title: "交付与支持",
          desc: "准时抵达您选择的港口，并配有专属客户经理。",
        },
      ],
    },
    compliance: {
      eyebrow: "出口就绪",
      title: "文件与合规，全程处理",
      desc: "从出口文件和质量证书，到定制包装与运输安排，我们的团队全程处理各项细节，确保您的货物顺利清关，避免任何延误。",
      items: [
        {
          title: "HACCP 与 ISO 22000",
          desc: "贯穿我们整个碾米业务的食品安全管理。",
        },
        {
          title: "植物检疫证书",
          desc: "为每批出口货物签发的官方植物卫生文件。",
        },
        { title: "原产地证书", desc: "供海关使用的、确认越南原产的完整单据。" },
        {
          title: "清真与洁食选项",
          desc: "可为中东及其他买家提供符合要求的加工处理。",
        },
      ],
    },
    cta: {
      title: "让我们把大米运往您的市场",
      desc: "告诉我们您的目的港、数量和包装需求——我们的出口团队将在一个工作日内回复专属报价。",
      ctaContact: "联系销售",
      ctaQuality: "我们的品质",
    },
  },
  contactPage: {
    hero: {
      eyebrow: "联系我们",
      title: "来聊聊吧",
      desc: "无论您需要报价、产品样品，还是长期供应伙伴，我们的出口团队都随时为您提供帮助。",
    },
    main: {
      eyebrow: "与我们联系",
      title: "期待您的来信",
      desc: "请通过下方表单或联系方式与我们取得联系。我们的出口专员会在一个工作日内回复每一封咨询。",
      info: [
        {
          label: "到访地址",
          value: "越南 胡志明市 富寿坊 3/2 街 968 号 The Everrich",
        },
        { label: "电子邮件", value: "info@everrice.vn" },
        { label: "联系电话", value: "+84 918335899" },
        { label: "工作时间", value: "周一至周六，8:00 – 17:00（GMT+7）" },
      ],
      ctaProducts: "浏览产品",
      ctaReach: "全球市场",
    },
    form: {
      title: "给我们留言",
      note: "带 * 的字段为必填项。",
      name: "姓名",
      namePh: "您的全名",
      email: "电子邮件",
      emailPh: "you@company.com",
      phone: "电话",
      phonePh: "+84 ...",
      message: "留言内容",
      messagePh: "请告诉我们您的目标市场、数量和包装需求……",
      submit: "发送信息",
      sending: "发送中……",
      success: "谢谢您！您的信息已发送——我们会尽快与您联系。",
      errorDefault: "未能发送您的信息，请重试。",
      network: "网络出现异常，请检查网络连接后重试。",
      extraLabel: "补充信息",
    },
    map: {
      eyebrow: "找到我们",
      title: "欢迎来到永禾",
    },
  },
};
